import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';

import { AddProductContainerCommand, DeActivateProductContainerCommand } from '@shared/models/commands';

import { ProductContainerActions, ProductContainersSelectors } from '@core/state/product-containers';
import { LoadingState } from '@core/models';


@Injectable({ providedIn: 'root' })
export class ProductContainersFacade {

  private readonly _store = inject(Store);

  // Signals for product-containers
  readonly callState = toSignal(this._store.select(ProductContainersSelectors.callState), { initialValue: LoadingState.INIT });
  readonly allProductContainers = toSignal(this._store.select(ProductContainersSelectors.all), { initialValue: [] });
  readonly productContainersByCategory = toSignal(this._store.select(ProductContainersSelectors.productContainersGroupedByCategory), { initialValue: [] });
  readonly isLoading = toSignal(this._store.select(ProductContainersSelectors.isLoading), { initialValue: false });
  readonly isLoaded = toSignal(this._store.select(ProductContainersSelectors.isLoaded), { initialValue: false });
  readonly total = toSignal(this._store.select(ProductContainersSelectors.total), { initialValue: 0 });
  readonly error = toSignal(this._store.select(ProductContainersSelectors.error), { initialValue: null });

  // Methods for product-containers
  loadProductContainers(): void {
    this._store.dispatch(ProductContainerActions.load());
  }

  addProductContainer(command: AddProductContainerCommand): void {
    this._store.dispatch(ProductContainerActions.add({ command }));
  }

  deActivateProductContainer(command: DeActivateProductContainerCommand): void {
    this._store.dispatch(ProductContainerActions.deActivate({ command }));
  }

  updateProductContainer(deactivateCommand: DeActivateProductContainerCommand, addCommand: AddProductContainerCommand): void {
    this._store.dispatch(ProductContainerActions.update({ deactivateCommand, addCommand }));
  }
}
